import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {GroupMember} from '../../graphql/groups.datatypes';
import {gqlGroupMember} from './getGroupMember.api';

interface GroupMemberData {
    groupMemberInMyGroup: GroupMember
}

export const GET_GROUP_MEMBER_QUERY = gql`
    query getGroupMemberInMyGroup($id: Int!){
        groupMemberInMyGroup(id: $id){
          ${gqlGroupMember}
        }
    }
`;

export const getGroupMemberInMyGroup = (groupMemberId: number | null) => {
  const id = groupMemberId ? groupMemberId : -1;
  return useQuery<GroupMemberData>(
    GET_GROUP_MEMBER_QUERY,
    {
      variables: {id}
    }
  );
};

export default getGroupMemberInMyGroup;